import { CommerceMedia } from '@api/types';
import { GalleryContext, Image } from '@components';
import { Box, styled } from '@mui/material';
import { useCallback, useContext, useMemo } from 'react';
// import { getEpiImageResizerUrl } from '@utils/images.utils';

const ImageListBox = styled(Box)`
  display: flex;
  overflow: hidden;
  gap: 16px;
`;

const ImageBox = styled(Box)`
  flex-basis: 20%;
  flex-grow: 0;
  background: #fff;
  padding: 8px;
  border-radius: 4px;
  cursor: pointer;
`;

const ImageBoxWrapper = styled(Box)`
  height: 0;
  padding-bottom: 70%;
  position: relative;
`;

const ImageBoxInner = styled(Box)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;

const MoreImagesBox = styled(ImageBox)`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  font-weight: 700;
  background: #e6eced;
`;

export type GalleryThumbsProps = {
  limit?: number;
};

export const GalleryThumbs = ({ limit = 4 }: GalleryThumbsProps) => {
  const { images = [], setCurrentImage, setIsModalOpen } = useContext(GalleryContext);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const imagesToDisplay = useMemo(() => images.slice(0, limit) || [], [images]);
  const imageCount = images.length;
  const hasImagesToDisplay = imagesToDisplay.length > 0;
  const showMoreImages = imageCount - limit > 0;

  const getImageUrl = useCallback((image: CommerceMedia) => image?.contentLink || {}, []);

  return (
    <ImageListBox>
      {hasImagesToDisplay && (
        <>
          {imagesToDisplay.map((x, key) => (
            <ImageBox key={key} onClick={() => setCurrentImage(key)}>
              <ImageBoxWrapper>
                <ImageBoxInner>
                  <Image
                    image={getImageUrl(x)}
                    scalingMode='fit'
                    resizerParams={{ width: 200, format: 'webp' }}
                    width='200'
                    height='200'
                  />
                </ImageBoxInner>
              </ImageBoxWrapper>
            </ImageBox>
          ))}

          {showMoreImages && (
            <MoreImagesBox
              onClick={() => {
                setIsModalOpen(true);
                setCurrentImage(limit);
              }}
            >
              +{imageCount - 4}
            </MoreImagesBox>
          )}
        </>
      )}
    </ImageListBox>
  );
};
